module.exports = __webpack_public_path__ + "img/guessa.174f372b.svg";